module.exports = __webpack_public_path__ + "img/galactica_blueprints_05.9bfca42e.png";